// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Divider from "@material-ui/core/Divider";

import type { StateType, DispatchType } from "../../global/types/redux";
import { StyledTabs } from "imagus-components";
import ResellerList from "./ResellerList";
import { fetchResellerList } from "../../actions/resellerActions";

class ResellersTabs extends Component<*> {

  componentDidMount() {
    this.props.actions.fetchResellerList();
  }

  render(): * {
    const resellers = this.props.reseller.resellers;
    let unconfirmedList = null;
    let confirmedList = null;
    if(resellers){
      unconfirmedList = resellers.filter(company => company.authorisedReseller === "UNCONFIRMED");
      confirmedList = resellers.filter(company => company.authorisedReseller === "TRUE");
    }

    const tabs = [
      { label: "Unconfirmed", component: <ResellerList resellers={unconfirmedList} />},
      { label: "Authorised", component: <ResellerList resellers={confirmedList} />}
    ];
    return (
      <div className="app-panel">
        <div className="app-panel-content panel-top-margin">
          <Divider />
          <StyledTabs tabs={tabs} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  reseller: state.v3admin.reseller
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ fetchResellerList }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ResellersTabs);
